export const typeFinder = value =>
  value instanceof Array ? "array" : value instanceof Object ? "object" : false;

export const collectionValidator = collection => {
  return collection.reduce((a, c) => {
    if (a === null) {
      return typeFinder(c);
    } else {
      return typeFinder(c) === a ? a : false;
    }
  }, null);
};



// export default function login() {
//   this.$store
//     .dispatch("auth/login", { email: this.email, password: this.password })
//     .then(
//       (data) => {
//         if (data.success == 1) {
//           this.errorMsg = "";
//           this.$router.push({
//             name: "Routes",
//           });
//         }
//       },
//       (data) => {
//         this.errorMsg = data["message"];
//       }
//     );
// }

// export function register() {
//   this.$store
//     .dispatch("auth/register", {
//       email: this.email,
//       password: this.password,
//     })
//     .then(
//       (data) => {
//         if (data.success == 1) {
//           this.errorMsg = "";
//           this.$router.push({
//             name: "OnboardingTeam",
//           });
//         }
//       },
//       (data) => {
//         if (data["message"] != null) {
//           this.errorMsg = data["message"];
//         } else {
//           this.errorMsg = "Error code " + data["err"];
//         }
//       }
//     );
// }


